import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BalanceDisplay from './BalanceDisplay';

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login');
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold font-heading text-primary"
          >
            🎯 My Bets
          </Link>

          {/* Nav links */}
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-text-secondary">
            <Link to="/" className="hover:text-primary transition-colors">
              Matches
            </Link>
            <Link to="/bets" className="hover:text-primary transition-colors">
              My Bets
            </Link>
            <Link to="/wallet" className="hover:text-primary transition-colors">
              Wallet
            </Link>
            {user && (
              <Link to="/partner" className="hover:text-primary transition-colors">
                Partner Program
              </Link>
            )}
          </nav>

          {/* Auth */}
          <div className="flex items-center gap-3">
            {user ? (
              <>
                {/* Live balance chip — auto-refreshes every 30s */}
                <Link
                  to="/wallet"
                  className="hidden sm:inline-flex items-center rounded-pill bg-primary/10 px-3 py-1 text-sm font-semibold text-primary hover:bg-primary/20 transition-colors"
                >
                  <BalanceDisplay />
                </Link>
                <span className="hidden sm:inline text-sm text-text-secondary truncate max-w-[120px]">
                  {user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="cursor-pointer rounded-button border border-border px-4 py-2 text-sm font-medium text-text-primary hover:bg-surface-2 transition-colors"
                >
                  Log out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="rounded-button border border-border px-4 py-2 text-sm font-medium text-text-primary hover:bg-surface-2 transition-colors"
                >
                  Log in
                </Link>
                <Link
                  to="/register"
                  className="rounded-button bg-primary px-4 py-2 text-sm font-semibold text-white shadow-btn hover:bg-primary-dark transition-colors"
                >
                  Sign up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
